import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
  isActive?: boolean;
}

const ChatSvg: FC<Props> = ({ className, color, isActive }) => {
  if (isActive) {
    return (
      <svg
        className={className}
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M8 2.5C6.30537 2.5 4.91332 2.94032 3.97968 3.67735C3.09048 4.37931 2.5 5.43671 2.5 7C2.5 8.64758 3.15584 9.74237 4.14751 10.4485L4.49536 10.6962L4.84321 10.9438L4.80775 11.3694L4.64863 13.2789C4.63871 13.3979 4.73264 13.5 4.85208 13.5C4.90208 13.5 4.95035 13.4817 4.98772 13.4484L6.97685 11.6803L7.19716 11.4845L7.49185 11.4911L7.78654 11.4976C7.85724 11.4992 7.92841 11.5 8 11.5C9.69463 11.5 11.0867 11.0597 12.0203 10.3226C12.9095 9.62069 13.5 8.56329 13.5 7C13.5 6.58579 13.8358 6.25 14.25 6.25C14.6642 6.25 15 6.58579 15 7C15 9.00015 14.2164 10.5001 12.9497 11.5C11.6831 12.4999 9.93319 13 8 13C7.91735 13 7.83504 12.9991 7.75309 12.9973L5.98426 14.5695C5.67231 14.8468 5.26945 15 4.85208 15C3.85508 15 3.07101 14.1479 3.15381 13.1543L3.27747 11.6704C1.87794 10.6739 1 9.11712 1 7C1 4.99985 1.78361 3.49991 3.05025 2.5C4.31689 1.50009 6.06681 1 8 1C8.36693 1 8.72623 1.01796 9.07618 1.05369C9.48825 1.09576 9.78819 1.46392 9.74612 1.87599C9.70405 2.28806 9.33589 2.588 8.92382 2.54593C8.62647 2.51557 8.31808 2.5 8 2.5Z'
          fill={color ?? 'currentColor'}
        />
        <path
          d='M14.5 3.5C14.5 4.60457 13.6046 5.5 12.5 5.5C11.3954 5.5 10.5 4.60457 10.5 3.5C10.5 2.39543 11.3954 1.5 12.5 1.5C13.6046 1.5 14.5 2.39543 14.5 3.5Z'
          fill='#FF3333'
        />
      </svg>
    );
  }
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.84321 10.9438L4.64863 13.2789C4.63871 13.3979 4.73264 13.5 4.85208 13.5C4.90208 13.5 4.95034 13.4817 4.98772 13.4484L7.19716 11.4845L7.78654 11.4976C7.85725 11.4992 7.92841 11.5 8 11.5C9.69482 11.5 11.0868 11.0596 12.0203 10.3226C12.9094 9.62078 13.5 8.56344 13.5 7C13.5 5.43656 12.9094 4.37922 12.0203 3.67735C11.0868 2.94041 9.69482 2.5 8 2.5C6.30518 2.5 4.9132 2.94041 3.97968 3.67735C3.09059 4.37922 2.5 5.43656 2.5 7C2.5 8.6477 3.15593 9.74243 4.14751 10.4485L4.84321 10.9438ZM5.98426 14.5695L7.75309 12.9973C7.83504 12.9991 7.91735 13 8 13C11.866 13 15 11 15 7C15 3 11.866 1 8 1C4.13401 1 1 3 1 7C1 9.117 1.87785 10.6738 3.27747 11.6704L3.15381 13.1543C3.07101 14.1479 3.85508 15 4.85208 15C5.26945 15 5.67231 14.8468 5.98426 14.5695Z'
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};

export default ChatSvg;
